import React from "react";
import logoUrl from "../../images/shared/logo.svg";
import { StyledImage } from "./Logo.styles";

const Logo = () => <StyledImage src={logoUrl} alt="Company logo" />;

export default Logo;
